import account from './locales/en/account/account.json';
import addLocation from './locales/en/addLocation/addLocation.json';
import aiVisibility from './locales/en/aiVisibility/aiVisibility.json';
import allLocations from './locales/en/allLocations/allLocations.json';
import forgotPassword from './locales/en/auth/forgotPassword.json';
import login from './locales/en/auth/login.json';
import resetPassword from './locales/en/auth/resetPassword.json';
import signUp from './locales/en/auth/signUp.json';
import verifyEmail from './locales/en/auth/verifyEmail.json';
import cbCampaignFlowAggregators from './locales/en/citation-builder/campaign-flow/aggregators.json';
import cbCampaignFlowBuildNew from './locales/en/citation-builder/campaign-flow/buildNew.json';
import cbCampaignFlowDeliverySpeed from './locales/en/citation-builder/campaign-flow/deliverySpeed.json';
import cbCampaignFlowFixExisting from './locales/en/citation-builder/campaign-flow/fixExisting.json';
import cbCampaignFlowReviewAndPay from './locales/en/citation-builder/campaign-flow/reviewAndPay.json';
import cbCampaignFlowScanResults from './locales/en/citation-builder/campaign-flow/scanResults.json';
import cbCampaignFlowShared from './locales/en/citation-builder/campaign-flow/shared.json';
import createLocationFindLocation from './locales/en/createLocation/findLocation.json';
import createLocationUpdateDetails from './locales/en/createLocation/updateLocationDetails.json';
import gbpInsights from './locales/en/gbpInsights/gbpInsights.json';
import addKeywords from './locales/en/getStarted/addKeywords.json';
import addPrompts from './locales/en/getStarted/addPrompts.json';
import businessDetails from './locales/en/getStarted/businessDetails.json';
import findLocation from './locales/en/getStarted/findLocation.json';
import gettingInsights from './locales/en/getStarted/gettingInsights.json';
import updateLocationDetails from './locales/en/getStarted/updateLocationDetails.json';
import labs from './locales/en/labs/labs.json';
import localRankTracker from './locales/en/localRankTracker/localRankTracker.json';
import localSearchGrid from './locales/en/localSearchGrid/localSearchGrid.json';
import locationSummary from './locales/en/locationSummary/locationSummary.json';
import darkModeSwitcher from './locales/en/modules/darkModeSwitcher.json';
import impersonation from './locales/en/modules/impersonation.json';
import keywords from './locales/en/modules/keywords.json';
import prompts from './locales/en/modules/prompts.json';
import rankings from './locales/en/modules/rankings.json';
import reportSchedule from './locales/en/modules/reportSchedule.json';
import settingsSection from './locales/en/modules/settingsSection.json';
import unsavedChanges from './locales/en/modules/unsavedChanges.json';
import replyTemplates from './locales/en/reviews/replyTemplates.json';
import reviewManager from './locales/en/reviews/reviewManager.json';
import reviewTracker from './locales/en/reviews/reviewTracker.json';
import appShell from './locales/en/shared/appShell.json';
import breadcrumbs from './locales/en/shared/breadcrumbs.json';
import common from './locales/en/shared/common.json';
import cardLoadError from './locales/en/shared/components/cardLoadError.json';
import failedRunAlert from './locales/en/shared/components/failedRunAlert.json';
import googleMap from './locales/en/shared/components/googleMap.json';
import googleOAuth from './locales/en/shared/components/googleOAuth.json';
import googlePlaceAutocomplete from './locales/en/shared/components/googlePlaceAutocomplete.json';
import gridMap from './locales/en/shared/components/gridMap.json';
import gridPointDrawer from './locales/en/shared/components/gridPointDrawer.json';
import reviewFilters from './locales/en/shared/components/reviewFilters.json';
import reviewReportScreens from './locales/en/shared/components/reviewReportScreens.json';
import runNotStartedAlert from './locales/en/shared/components/runNotStartedAlert.json';
import runQuotaExceededAlert from './locales/en/shared/components/runQuotaExceededAlert.json';
import updateDataButton from './locales/en/shared/components/updateDataButton.json';
import countrySupport from './locales/en/shared/countrySupport.json';
import errors from './locales/en/shared/errors.json';
import forms from './locales/en/shared/forms.json';
import location from './locales/en/shared/location.json';
import oldPlatformRedirectModal from './locales/en/shared/oldPlatformRedirectModal.json';
import toolAccess from './locales/en/shared/toolAccess.json';

export const enTranslation = {
  appShell,
  breadcrumbs,
  common,
  countrySupport,
  errors,
  location,
  forms,
  oldPlatformRedirectModal,
  toolAccess,
  darkModeSwitcher,
  impersonation,
  unsavedChanges,
  settingsSection,
  googlePlaceAutocomplete,
  googleOAuth,
  googleMap,
  gridMap,
  gridPointDrawer,
  cardLoadError,
  failedRunAlert,
  reviewFilters,
  reviewReportScreens,
  runNotStartedAlert,
  runQuotaExceededAlert,
  updateDataButton,
  createLocation: {
    findLocation: createLocationFindLocation,
    updateLocationDetails: createLocationUpdateDetails
  },
  getStarted: {
    addKeywords,
    addPrompts,
    businessDetails,
    findLocation,
    gettingInsights,
    updateLocationDetails
  },
  account,
  addLocation: { addLocation },
  allLocations: { allLocations },
  reports: {
    localSearchGrid,
    localRankTracker,
    aiVisibility,
    gbpInsights,
    reviewTracker,
    reviewManager,
    replyTemplates
  },
  labs,
  keywords,
  prompts,
  reportSchedule,
  locationSummary,
  rankings,
  auth: { forgotPassword, login, resetPassword, signUp, verifyEmail },
  citationBuilder: {
    campaignFlow: {
      shared: cbCampaignFlowShared,
      scanResults: cbCampaignFlowScanResults,
      fixExisting: cbCampaignFlowFixExisting,
      buildNew: cbCampaignFlowBuildNew,
      aggregators: cbCampaignFlowAggregators,
      deliverySpeed: cbCampaignFlowDeliverySpeed,
      reviewAndPay: cbCampaignFlowReviewAndPay
    }
  }
} as const;
